import { LabelItemDefaultView, LabelItemForUnionView } from '@src/api';
import { _ } from '@ngx-translate/core';

import { NavigationItemNames } from '../navigation';

export enum VisibilityEnum {
  'INVISIBLE' = 'nobody',
  'ADMINISTRATORS' = 'adminOnly',
  'ALL' = 'all',
}
export const VisibilityNames = {
  [VisibilityEnum.INVISIBLE]: _('components.customName.constants.visibilityOptions.invisible'),
  [VisibilityEnum.ADMINISTRATORS]: _('components.customName.constants.visibilityOptions.administrators'),
  [VisibilityEnum.ALL]: _('components.customName.constants.visibilityOptions.all'),
};

export type ObjectType = 'organisation' | 'committee' | 'navigation';

export type CustomNamesItem = LabelItemDefaultView & LabelItemForUnionView & { defaultTitle?: string };

export type CodeName =
  | NavigationItemNames
  | 'field.jobTitle'
  | 'field.committeeManager'
  | 'label.committeeMembers'
  | 'field.committeeSecretary'
  | 'label.organisationMembers'
  | 'label.userProfileAttachment';
